<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="availForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div *ngIf="ShowAvail" class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Availability Request
                            </b></h3>
                    </div>
                </div>
                <div *ngIf="ShowExaminer" class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Examiner Assignment Request
                            </b></h3>
                    </div>
                </div>

                <hr>
                <div *ngIf="ShowAvail" class="row clearfix">
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Request Type</mat-label>
                            <input readonly maxlength="150" matInput formControlName="reqtyp">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Date Range</mat-label>
                            <input readonly maxlength="150" matInput formControlName="dateRange">
                        </mat-form-field>
                    </div>
                    
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Availability Status</mat-label>
                            <mat-select required formControlName="Availability" #select143
                                placeholder="Select" class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option [value]=1 (click)="availableStatus(1)">Yes</mat-option>
                                <mat-option [value]=0 (click)="availableStatus(0)">No</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="availForm.controls['Availability'].touched && availForm.controls['Availability'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div *ngIf="showAddReason" class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Reason</mat-label>
                            <input maxlength="150" matInput formControlName="Reason">
                             <mat-error class="margin_tp"
                                *ngIf="availForm.controls['Reason'].touched && availForm.controls['Reason'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button (click)="update()" id="Save" type="button" class="btn btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Update
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="ShowExaminer" class="row clearfix">
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Request Type</mat-label>
                            <input readonly maxlength="150" matInput formControlName="reqtyp">
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Date Range</mat-label>
                            <input readonly maxlength="150" matInput formControlName="dateRange">
                        </mat-form-field>
                    </div>
                     -->
                    <div class="col-sm-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Acceptence Status</mat-label>
                            <mat-select required formControlName="AcceptStatus" #select143
                                placeholder="Select" class="colorblack">
                                <mat-option>Select</mat-option>
                                <mat-option [value]=1 (click)="requestAcceptenceClick(1)">Accept</mat-option>
                                <mat-option [value]=0 (click)="requestAcceptenceClick(0)">Reject</mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="availForm.controls['Availability'].touched && availForm.controls['Availability'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button (click)="updateTeacherAssignment()" id="Save" type="button" class="btn btn-primary btn-icon-text floatright mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Update
                                </span>
                            </button>
                            <button id="Back" type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    {{'header.faculty-data.titleList.Back'
                                    | translate}}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>